import { Component, EventEmitter, Input, Output } from '@angular/core'
import { NgClass, NgIf } from '@angular/common'

@Component({
  selector: 'app-checkbox',
  standalone: true,
    imports: [
        NgIf,
        NgClass
    ],
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.scss'
})
export class CheckboxComponent {
    @Input() checked: boolean = false
    @Input() disabled: boolean = false

    @Output() checkboxChange = new EventEmitter<boolean>()

    onCheckboxChecked(value: boolean) {
        if(this.disabled) return;

        this.checked = value
        this.checkboxChange.emit(this.checked)
    }

}
